/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const Byte = zod.object({

}).passthrough();

export type Byte = zod.input<typeof Byte>;
export type ByteOutput = zod.output<typeof Byte>;
